export default __webpack_public_path__ + "static/shaw-shooting-4cbe374ff56b99141ca942cfa5a30db8.svg";